import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaExternalLinkAlt } from 'react-icons/fa';
import Hero from '../../components/Hero/Hero';
import heroBg from '../../assets/images/hero/tspc-banner.png';
import './Contact.css';

const emails = [
  { address: 'prod_sales@tokyosteel.com.ph', label: 'Product Sales' },
];

const phones = [
  { number: '+63-32-340-3753', label: 'Main Line' },
  { number: '+63-32-344-5038', label: 'Line 2' },
];

const Contact = () => (
  <div>
    <Hero
      title={<>Contact <span className="highlight">Us</span></>}
      subtitle="Get in touch with us. We'd love to hear from you."
      backgroundImage={heroBg}
    />

    <section className="contact__reach section">
      <div className="container">
        <p className="section-label">Reach Us Directly</p>
        <h2 className="section-title">How to <span className="highlight">Contact Us</span></h2>
        <p className="contact__desc">Click any email or phone number below to reach us directly. Our team responds within one business day.</p>

        <div className="contact__methods">
          <div className="contact-method-card">
            <div className="contact-method-card__header">
              <div className="contact-method-card__icon"><FaEnvelope /></div>
              <h3>Email Us</h3>
            </div>
            <p className="contact-method-card__hint">Click to open your email client</p>
            <div className="contact-method-card__links">
              {emails.map((e, i) => (
                <a key={i} href={`mailto:${e.address}`} className="contact-link">
                  <div className="contact-link__info">
                    <span className="contact-link__label">{e.label}</span>
                    <span className="contact-link__value">{e.address}</span>
                  </div>
                  <FaExternalLinkAlt className="contact-link__arrow" />
                </a>
              ))}
            </div>
          </div>

          <div className="contact-method-card">
            <div className="contact-method-card__header">
              <div className="contact-method-card__icon"><FaPhoneAlt /></div>
              <h3>Call Us</h3>
            </div>
            <p className="contact-method-card__hint">Click to dial (mobile devices)</p>
            <div className="contact-method-card__links">
              {phones.map((p, i) => (
                <a key={i} href={`tel:${p.number.replace(/-/g, '')}`} className="contact-link">
                  <div className="contact-link__info">
                    <span className="contact-link__label">{p.label}</span>
                    <span className="contact-link__value">{p.number}</span>
                  </div>
                  <FaExternalLinkAlt className="contact-link__arrow" />
                </a>
              ))}
            </div>
          </div>

          <div className="contact-method-card">
            <div className="contact-method-card__header">
              <div className="contact-method-card__icon"><FaMapMarkerAlt /></div>
              <h3>Visit Us</h3>
            </div>
            <p className="contact-method-card__hint">Click to open in Google Maps</p>
            <div className="contact-method-card__links">
              <a href="https://maps.google.com/?q=5th+Street+corner+3rd+Avenue+MEPZ+1+Lapu-Lapu+City+Cebu" target="_blank" rel="noopener noreferrer" className="contact-link">
                <div className="contact-link__info">
                  <span className="contact-link__label">Factory Address</span>
                  <span className="contact-link__value">5th Street corner 3rd Avenue MEPZ 1, Ibo, Lapu-Lapu City, Cebu, Philippines</span>
                </div>
                <FaExternalLinkAlt className="contact-link__arrow" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="contact__map-section section">
      <div className="container">
        <p className="section-label">Our Location</p>
        <h2 className="section-title">Find <span className="highlight">Us</span></h2>
        <div className="contact__map">
          <iframe
            title="TSPC Location"
            src="https://maps.google.com/maps?q=5th+Street+corner+3rd+Avenue+MEPZ+1+Lapu-Lapu+City+Cebu&t=m&z=14&output=embed&iwloc=near"
            width="100%" height="100%" style={{ border: 0 }}
            allowFullScreen loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            sandbox="allow-scripts allow-same-origin allow-popups"
          />
        </div>
      </div>
    </section>
  </div>
);

export default Contact;
